<template>
  <div class="completePanel">
    <div class="title">
      合并列表
    </div>
    <ul
      v-show="dataList.length != 0"
      id="convert-video-list"
    >
      <li
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="item">
          <div class="cover">
            <img :src="$.handleAssetsUrl(item.cover)">
          </div>
          <div class="mask"></div>

          <!-- <div
            v-if="item.outputFormat != 'MP4' && item.outputFormat != 'MOV'"
            class="notSupportPlay"
          >
            <div class="icon">
              <iconfont
                name="#icon13-5wufayulan"
                font-size="23px"
              ></iconfont>
            </div>
            <div class="tip">
              该格式暂不支持预览
            </div>
          </div>-->

          <div
            class="play"
            @click="play(item)"
          >
            <iconfont
              name="#icon11-11zantingbofanganniu"
              font-size="12px"
            ></iconfont>
          </div>
          <div
            class="delete"
            @click="deleteItem(item)"
          >
            <iconfont
              class="normal"
              name="#icon12-12shanchu"
              font-size="12px"
            ></iconfont>
            <iconfont
              class="hover"
              name="#icon12-12shanchujiaohu"
              font-size="12px"
            ></iconfont>
          </div>
          <div class="duration">
            {{ item.durationString }}
          </div>
        </div>

        <div class="name">
          <!-- {{ item.name }} -->
          <text-show-tip :text="item.name"></text-show-tip>
        </div>
      </li>
    </ul>
    <div
      v-show="dataList.length == 0"
      class="emptyTip"
    >
      <span>还没有任何作品哦</span>
    </div>

    <div
      v-show="dataList.length > 0"
      class="clear"
      @click="clear"
    >
      <div class="icon">
        <iconfont
          class="normal"
          name="#icon12-12shanchu"
          font-size="16px"
        ></iconfont>
        <iconfont
          class="hover"
          name="#icon12-12shanchujiaohu"
          font-size="16px"
        ></iconfont>
      </div>
      <div>清空列表</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CompletePanel',
  components: {
    TextShowTip: () => import('@/components/common/textShowTip')
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      dataList: 'merge/getFiles'
    })
  },
  watch: {},
  methods: {
    deleteItem(item) {
      this.$modal.show('MessageDialog', {
        content: '是否确认删除该文件？',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (!value) return;
          if (value.type == 'Ok') {
            this.$store.commit('merge/deleteFile', item);
          }
        }
      });
    },
    clear() {
      this.$modal.show('MessageDialog', {
        content: '是否确定要清空当前的列表内容？（操作不可恢复）',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (!value) return;
          if (value.type == 'Ok') {
            this.$store.commit('merge/clearFiles');
          }
        }
      });
    },
    play(item) {
      this.$modal.show('videoPlayModal', item);
    }
  }
};
</script>

<style scoped lang="scss">
.completePanel {
  position: relative;
  width: 326px;
  height: 100%;
  background-color: #fff;
  margin: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  box-shadow: 0px 10px 20px 0px rgba(90, 98, 179, 0.1);
  border-radius: 4px;
  .title {
    font-size: 16px;
    height: 16px;
    width: 100%;
    font-weight: bold;
    color: #333333;
    text-align: left;
    padding-left: 33px;
    background-color: #fff;
    margin-top: 30px;
  }

  > ul {
    width: 100%;
    position: relative;
    flex-grow: 1;
    overflow: auto;
    margin-top: 24px;
    padding-left: 33px;
    > li {
      width: 100%;
      height: 176px;
      margin-top: 24px;
      .item {
        position: relative;
        width: 260px;
        height: 147px;
        position: relative;
        background-color: #f2f4f8;
        border: 1px solid #d7d7d7;
        border-radius: 4px;

        .cover {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          overflow: hidden;
          > img {
            max-height: 100%;
            max-width: 100%;
          }
        }
        .notSupportPlay {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: #5383fd;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .tip {
            font-size: 14px;
            color: #fff;
            margin-top: 11px;
          }
        }

        .delete {
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          width: 30px;
          height: 30px;

          background: #ffffff;
          box-shadow: 0px 3px 10px 0px rgba(90, 98, 180, 0.18);
          border-radius: 50%;
          position: absolute;

          right: 9px;
          top: 9px;
          transition: all 0.3s;
          cursor: pointer;

          .hover {
            display: none;
          }

          &:hover {
            .normal {
              display: none;
            }
            .hover {
              display: block;
            }
          }
        }
        .play {
          //display: none;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          position: absolute;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          color: #2f58fe;
          transform: translate(-50%, -50%);
          background-color: rgba(255, 255, 255, 0.8);
          transition: opacity 0.3s;
          cursor: pointer;
        }
        .duration {
          position: absolute;
          right: 9px;
          bottom: 9px;
          width: 50px;
          height: 21px;
          color: #fff;
          background: #000000;
          opacity: 0.6;
          border-radius: 4px;
          line-height: 21px;
        }

        .mask {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          background-color: rgba(0, 0, 0, 0.3);
          transition: all 0.3s;
        }

        &:hover {
          .play,
          .delete {
            opacity: 1;
          }
          .mask {
            display: block;
          }
        }
      }
      .name {
        width: 260px;
        height: 30px;
        padding-top: 15px;
        text-align: center;
        color: #333333;
        font-size: 14px;
        overflow: hidden;
      }
    }
    > li:first-child {
      margin-top: 0px;
    }

    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &div::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #d5d6dc;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #bdbdbe;
    }
  }
  .emptyTip {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #666666;
    margin-top: -46px;
  }
  .clear {
    font-size: 14px;
    align-self: flex-end;
    margin-top: 18px;
    margin-right: 31px;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 6px;

      .hover {
        display: none;
      }
    }
    &:hover {
      .normal {
        display: none;
      }
      .hover {
        display: block;
      }
    }
  }
}
</style>
